import { Controller } from 'react-hook-form'
import * as z from 'zod'

import { ScoreRadio } from '~/@mid_ui-form/score-radio/ScoreRadio'
import { ScoreRadioGroup } from '~/@mid_ui-form/score-radiu-group/ScoreRadioGroup'
import { FormStep } from '~/@pages_onboarding/investor-analysis/_analysis-form/FormStep'
import { StepTitle } from '~/@pages_onboarding/investor-analysis/_analysis-form/StepTitle'
import { useFormStepUnsophisticated } from '../../form-step-unsophisticated/useFormStepUnsophisticated'
import { useQuestionsV1 } from '../../../questions'

const step3Schema = z.object({
  investmentGoal: z.object({
    value: z.enum([
      'protectAgainstInflationMinimalRisk',
      'growAssetsWithModerateMarketRisk',
      'significantlyGrowAssetsEvenAtTheCostOfLoss',
    ]),
    score: z.number(),
  }),
})

export type Step3Data = z.infer<typeof step3Schema>

export function Step3() {
  const { onStepCompleted, formData } = useFormStepUnsophisticated()
  const { unsophisticated: unsophisticatedQuestions } = useQuestionsV1()

  return (
    <FormStep
      defaultValues={formData}
      schema={step3Schema}
      onStepCompleted={onStepCompleted}
      render={({ control }) => (
        <>
          <StepTitle>
            {unsophisticatedQuestions.investmentGoal.question.label}
          </StepTitle>
          <Controller
            control={control}
            name="investmentGoal"
            render={({ field }) => (
              <ScoreRadioGroup
                value={field.value}
                onValueChange={field.onChange}>
                {Object.entries(
                  unsophisticatedQuestions.investmentGoal.answers
                ).map(([value, answer]) => (
                  <ScoreRadio
                    key={value}
                    score={answer.score}
                    value={value}
                    label={answer.label}
                  />
                ))}
              </ScoreRadioGroup>
            )}
          />
        </>
      )}
    />
  )
}
